/*
  QREW pre-order countdown.

  Liquid renders the deadline once as a fixed epoch (data-deadline) plus a
  server-computed first frame, so the markup is correct even straight off the
  CDN cache. Everything after that is browser-clock arithmetic — remaining time
  is never computed in Liquid, because cached HTML would serve a stale value.

  At zero the element removes itself entirely.
*/
(function () {
  'use strict';

  var SELECTOR = '[data-qrew-countdown]';

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function setPart(root, name, value) {
    var node = root.querySelector('[data-cd-' + name + ']');
    if (node && node.textContent !== value) node.textContent = value;
  }

  function dropDays(root) {
    var group = root.querySelector('[data-cd-days-group]');
    if (group) group.remove();
    var sep = root.querySelector('[data-cd-days-sep]');
    if (sep) sep.remove();
  }

  // Returns false once the deadline has passed, so callers stop ticking.
  function render(root) {
    var deadline = Number(root.getAttribute('data-deadline'));
    if (!deadline) {
      root.remove();
      return false;
    }

    var remaining = deadline - Date.now();
    if (remaining <= 0) {
      root.remove();
      return false;
    }

    var total = Math.floor(remaining / 1000);

    // Days is present only while a whole day remains. Once it hits zero the
    // segment and its trailing separator are dropped, leaving HH : MM : SS.
    var days = Math.floor(total / 86400);
    if (days > 0) {
      setPart(root, 'days', pad(days));
    } else {
      dropDays(root);
    }

    setPart(root, 'hours', pad(Math.floor((total % 86400) / 3600)));
    setPart(root, 'minutes', pad(Math.floor((total % 3600) / 60)));
    setPart(root, 'seconds', pad(total % 60));
    return true;
  }

  function start(root) {
    if (root.dataset.qrewCountdownStarted) return;
    root.dataset.qrewCountdownStarted = '1';

    if (!render(root)) return;

    var timer = setInterval(function () {
      if (!render(root)) clearInterval(timer);
    }, 1000);

    // Background tabs throttle setInterval to roughly once a minute, so the
    // clock drifts while hidden. Resync the moment the tab is looked at again.
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && root.isConnected) render(root);
    });
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor re-renders sections in place without a page load.
  document.addEventListener('shopify:section:load', init);
})();
